import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "support-deduct-modal" }
const _hoisted_2 = { class: "support-deduct-modal__head" }
const _hoisted_3 = { class: "support-deduct-modal__title" }
const _hoisted_4 = { class: "support-deduct-modal__body" }
const _hoisted_5 = { class: "support-deduct-modal__desc" }
const _hoisted_6 = {
  key: 0,
  class: "support-deduct-modal__empty"
}
const _hoisted_7 = {
  key: 1,
  class: "support-deduct-modal__list"
}
const _hoisted_8 = { class: "support-deduct-modal__label" }
const _hoisted_9 = ["checked", "onChange"]
const _hoisted_10 = { class: "support-deduct-modal__name" }
const _hoisted_11 = { class: "support-deduct-modal__amount" }
const _hoisted_12 = {
  key: 2,
  class: "support-deduct-modal__summary"
}
const _hoisted_13 = { class: "support-deduct-modal__summary-row" }
const _hoisted_14 = { class: "support-deduct-modal__summary-label" }
const _hoisted_15 = { class: "support-deduct-modal__summary-value" }
const _hoisted_16 = { class: "support-deduct-modal__summary-row support-deduct-modal__summary-row--total" }
const _hoisted_17 = { class: "support-deduct-modal__summary-label" }
const _hoisted_18 = { class: "support-deduct-modal__summary-value" }
const _hoisted_19 = {
  key: 0,
  class: "support-deduct-modal__formula"
}
const _hoisted_20 = { class: "support-deduct-modal__footer" }

import { computed, ref, watch } from 'vue';
import {
  HOME_WAGE_SUPPORT_DEDUCTION_UI,
  type HomeWageSupportDeductionItemFlags,
  type HomeWageSupportDeductionItemKey,
  type HomeWageSupportDeductionItemRow,
} from '@/policies/homeWageSupportDeductionPolicy';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageSupportDeductionModal',
  props: {
    modelValue: { type: Boolean },
    items: {},
    flags: {},
    baseTotal: {},
    previewTotal: {},
    formula: {},
    formatMoney: { type: Function }
  },
  emits: ["update:modelValue", "cancel", "apply", "update:flags"],
  setup(__props: any, { emit: __emit }) {

const ui = HOME_WAGE_SUPPORT_DEDUCTION_UI;

const props = __props;

const emit = __emit;

const localFlags = ref<HomeWageSupportDeductionItemFlags>({ ...props.flags });

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      localFlags.value = { ...props.flags };
    }
  }
);

watch(
  () => props.flags,
  (flags) => {
    if (!props.modelValue) {
      localFlags.value = { ...flags };
    }
  },
  { deep: true }
);

const onToggleItem = (key: HomeWageSupportDeductionItemKey, checked: boolean) => {
  localFlags.value = { ...localFlags.value, [key]: checked };
  emit('update:flags', { ...localFlags.value });
};

const baseTotal = computed(() => props.baseTotal);
const previewTotal = computed(() => props.previewTotal);
const formula = computed(() => props.formula || '');

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "460",
    persistent: "",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(ui).modalTitle), 1),
          _createElementVNode("button", {
            type: "button",
            class: "support-deduct-modal__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(ui).modalDesc), 1),
          (__props.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(ui).emptyList), 1))
            : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.key,
                    class: "support-deduct-modal__row"
                  }, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "support-deduct-modal__check",
                        checked: localFlags.value[item.key],
                        onChange: ($event: any) => (onToggleItem(item.key, ($event.target as HTMLInputElement).checked))
                      }, null, 40, _hoisted_9),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(__props.formatMoney(item.amount)), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "support-deduct-modal__unit" }, "원", -1))
                    ])
                  ]))
                }), 128))
              ])),
          (__props.items.length > 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(ui).targetSumLabel), 1),
                  _createElementVNode("span", _hoisted_15, [
                    _createTextVNode(_toDisplayString(__props.formatMoney(baseTotal.value)), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "support-deduct-modal__unit" }, "원", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(ui).previewLabel), 1),
                  _createElementVNode("span", _hoisted_18, [
                    _createTextVNode(_toDisplayString(__props.formatMoney(previewTotal.value)), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "support-deduct-modal__unit" }, "원", -1))
                  ])
                ]),
                (formula.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(formula.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("footer", _hoisted_20, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-cancel",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("취소", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-confirm",
            size: "small",
            disabled: __props.items.length === 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('apply')))
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" 적용 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})